"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAccountId = void 0;
const buildAccountId = ({ appDefId, appInstanceId }) => `${appDefId}:${appInstanceId}`;
exports.buildAccountId = buildAccountId;
//# sourceMappingURL=utils.js.map